export default "__VITE_ASSET__mXfkhfik__"